import { h, Component } from 'preact';
import { isWebPSupported } from 'utils/isWebPSupported';
import s from 'components/bolt/hub/components/video/video.sss';


export default class Video extends Component {
	constructor(props) {
		super(props);
		this.playVideo = this.playVideo.bind(this);
	}

	componentDidMount() {
		this.playVideo();
	}

	componentDidUpdate(prevProps) {
		const activePerc = this.props.hubActivePercentage;

		if (activePerc !== prevProps.hubActivePercentage) {
			if (activePerc <= 0.5 && !this.$video.paused) {
				this.$video.pause();
			}

			if (activePerc >= 0.5 && this.$video.paused) {
				this.$video.play();
			}
		}
		
		if (this.props.isTileVideo && this.$video.paused) {
			this.playVideo();
		}
	}

	playVideo() {
		if (this.$video && (this.props.hubActivePercentage >= 0.5 || this.props.isTileVideo)) {
			this.$video.play()
				.catch(this.props.onError);
		}
	}

	render(props) {
		const { src, ariaLabel, onError, preloadImg, fallbackFormat, onPlay, onProgress, autoplay = true } = props;

		return (
			<video
				ref={ref => this.$video = ref}
				src={src}
				onError={onError}
				onPlay={onPlay}
				onProgress={onProgress}
				autoplay={autoplay}
				muted
				loop
				playsinline
				key={src}
				class={s.vid}
				ariaLabel={ariaLabel}
				poster={isWebPSupported ? preloadImg : preloadImg.replace(/\.[^.]*$/, fallbackFormat)}
			>
				{src.endsWith('.webm') && <source src={src} type="video/webm" />}
				<source src={src.replace(/\.[^.]*$/, '.mp4')} type="video/mp4" />
			</video>
		);

	}
}
